
import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import ProcessSection from './components/ProcessSection';
import BenefitsSection from './components/BenefitsSection';
import BrandsSection from './components/BrandsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ServiceAreasSection from './components/ServiceAreasSection';
import CtaSection from './components/CtaSection';
import MiniFaqSection from './components/MiniFaqSection';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Instalación de Pladur en Barcelona | PLADUREX - Profesional';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Instalación de pladur en Barcelona: tabiques, trasdosados, falsos techos y aislamientos. Presupuesto sin compromiso. Trabajo profesional desde Sant Andreu.'
      );
    }

    // Add WebPage Schema
    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Instalación de Pladur en Barcelona | PLADUREX",
      "description": "Instalación de pladur en Barcelona: tabiques, trasdosados, falsos techos y aislamientos. Presupuesto sin compromiso.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://barcelona.pladures.es'}/`,
      "inLanguage": "es-ES",
      "isPartOf": {
        "@type": "WebSite",
        "name": "PLADUREX Barcelona",
        "url": import.meta.env.VITE_SITE_URL || 'https://barcelona.pladures.es'
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(webPageSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <StatsSection />
        <ProcessSection />
        <BenefitsSection />
        <BrandsSection />
        <TestimonialsSection />
        <ServiceAreasSection />
        <MiniFaqSection />
        <CtaSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default HomePage;
